__turbopack_context__.v({
  "app_light_theme": "bonuses-panel-module-scss-module__5_EF_W__app_light_theme",
  "arrowIcon": "bonuses-panel-module-scss-module__5_EF_W__arrowIcon",
  "auth": "bonuses-panel-module-scss-module__5_EF_W__auth",
  "content": "bonuses-panel-module-scss-module__5_EF_W__content",
  "cup": "bonuses-panel-module-scss-module__5_EF_W__cup",
  "disabled": "bonuses-panel-module-scss-module__5_EF_W__disabled",
  "drawer__calc": "bonuses-panel-module-scss-module__5_EF_W__drawer__calc",
  "modal__calc": "bonuses-panel-module-scss-module__5_EF_W__modal__calc",
  "root": "bonuses-panel-module-scss-module__5_EF_W__root",
  "root__open": "bonuses-panel-module-scss-module__5_EF_W__root__open",
  "wrapper": "bonuses-panel-module-scss-module__5_EF_W__wrapper",
});
